import { render, staticRenderFns } from "./IrRefunds.vue?vue&type=template&id=ec0257ca&"
import script from "./IrRefunds.vue?vue&type=script&lang=js&"
export * from "./IrRefunds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports